import {
  TRemoteBankingContactsStore,
  TResponsiblePersonsInfo,
} from '~/store/remote-banking-contacts/types.ts';
import { PayloadAction } from '@reduxjs/toolkit';
import { TResponsiblePersons } from '~/modules/remote-banking-contacts/type.ts';

export const responsiblePersonsFulfilled = (state: TRemoteBankingContactsStore) => {
  state.loading = false;
  state.error = null;
  state.status = '';
};

export const responsiblePersonsFormFulfilled = (
  state: TRemoteBankingContactsStore,
  action: PayloadAction<TResponsiblePersons>
) => {
  state.formPersons = action.payload;
  state.loading = false;
  state.error = null;
  state.status = '';
};

export const responsiblePersonsInfoFormFulfilled = (
  state: TRemoteBankingContactsStore,
  action: PayloadAction<TResponsiblePersonsInfo>
) => {
  state.formPersonsInfo = action.payload;
  state.loading = false;
  state.error = null;
  state.status = '';
};

export const responsiblePersonsPending = (state: TRemoteBankingContactsStore) => {
  state.loading = true;
};
